import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const BulkActionsBar = ({ selectedCount, onVerifySelected, onSuspendSelected, onEmailSelected, onExportSelected, onDeselectAll }) => {
  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50 animate-slide-in">
      <div className="bg-card rounded-lg border border-border elevation-3 p-4 flex items-center gap-4 shadow-lg">
        <div className="flex items-center gap-2 px-3 py-1 bg-primary/10 rounded-full">
          <Icon name="CheckSquare" size={16} color="var(--color-primary)" />
          <span className="text-sm font-medium text-primary">{selectedCount} selected</span>
        </div>

        <div className="h-6 w-px bg-border" />

        <div className="flex items-center gap-2">
          <Button
            variant="ghost"
            size="sm"
            iconName="CheckCircle"
            iconPosition="left"
            onClick={onVerifySelected}
          >
            Verify
          </Button>
          <Button
            variant="ghost"
            size="sm"
            iconName="Ban"
            iconPosition="left"
            onClick={onSuspendSelected}
          >
            Suspend
          </Button>
          <Button
            variant="ghost"
            size="sm"
            iconName="Mail"
            iconPosition="left"
            onClick={onEmailSelected}
          >
            Email
          </Button>
          <Button
            variant="ghost"
            size="sm"
            iconName="Download"
            iconPosition="left"
            onClick={onExportSelected}
          >
            Export
          </Button>
        </div>

        <div className="h-6 w-px bg-border" />

        <Button
          variant="ghost"
          size="sm"
          iconName="X"
          onClick={onDeselectAll}
        />
      </div>
    </div>
  );
};

export default BulkActionsBar;